export default "__VITE_ASSET__DyvzsgJh__"